// The only place that knows the delivery-scoped release collection and field
// names (learner experience handoff §7).
//
// PROPOSED — this collection does not exist yet. It is the smallest truthful
// representation of "activity X is released for Lesson Delivery Y":
//
//   learner_activity_releases
//     id               uuid, primary key
//     sync_key         uuid, required, unique  (UUID v5 of delivery + activity)
//     lesson_delivery  m2o → Lesson_Deliveries.id, required
//     learner_activity m2o → learner_activities.id, required
//     released_at      timestamp, required, written once
//     + Directus user_created / date_created
//
// The unique sync_key makes release idempotent on the server: a second release
// of the same activity for the same delivery can never become a second row.

import { uuidV5 } from "./uuidV5";

export const RELEASE_COLLECTION = "learner_activity_releases";
export const RELEASE_FIELDS = ["id", "sync_key", "released_at"];

// Fixed namespace for release keys. Never change it: existing keys depend on it.
const RELEASE_NAMESPACE = "c3f1e0a4-8b52-4f67-9d1a-6e2b7a4c5d90";

export const releaseKey = (deliveryId, activityId) =>
  uuidV5(`${deliveryId}:${activityId}`, RELEASE_NAMESPACE);

export const bySyncKey = (syncKey) => ({ sync_key: { _eq: syncKey } });

// Identity and release time are written once and never rewritten.
export const newRelease = ({ deliveryId, activityId, releasedAt }) => ({
  sync_key: releaseKey(deliveryId, activityId),
  lesson_delivery: deliveryId,
  learner_activity: activityId,
  released_at: releasedAt,
});

export const toRelease = (row) =>
  row ? { id: row.id, releasedAt: row.released_at || null } : null;
